export default __webpack_public_path__ + "static/media/06.36cebcd1.jpg";